

export const TeacherReportShow = () => {
    return (
        <div>

        </div>
    )
}